export const handleIsOfferInCart = (addedOffers: any) => {
    let isOfferInCart;

    if (addedOffers !== undefined) {
        isOfferInCart = (addedOffers?.length > 0);
    }

    return isOfferInCart;
}
